export default "__VITE_ASSET__5c047c67__"